import { getDashboardPathByPlatform } from 'src/utils/appDeviceBridge'
import Router from 'next/router'
import { refreshSidebarDevices } from 'src/utils/refreshSidebarDevices'

export const BINDING_OUTCOME = {
  SUCCESS: 'success',
  ALREADY_BOUND: 'already_bound',
  EXPIRED: 'expired',
  FAILED: 'failed'
}

/**
 * 解析 user-binding-device / order-binding-device 响应。
 * 优先读 bindStatus；无该字段时兼容旧返回。
 * @param {object|null|undefined} result
 * @returns {'success'|'already_bound'|'expired'|'failed'}
 */
export const getBindingDeviceOutcome = result => {
  if (!result) return BINDING_OUTCOME.FAILED

  const status = result.bindStatus
  if (status === BINDING_OUTCOME.ALREADY_BOUND) return BINDING_OUTCOME.ALREADY_BOUND
  if (status === BINDING_OUTCOME.EXPIRED) return BINDING_OUTCOME.EXPIRED
  if (status === BINDING_OUTCOME.SUCCESS) return BINDING_OUTCOME.SUCCESS
  if (status === BINDING_OUTCOME.FAILED) return BINDING_OUTCOME.FAILED

  if (result.code === 1001) return BINDING_OUTCOME.EXPIRED
  if (result.code === 500 && result.msg === 'Expired') return BINDING_OUTCOME.EXPIRED
  if (result.code === 0) return BINDING_OUTCOME.SUCCESS

  return BINDING_OUTCOME.FAILED
}

export const isBindingDeviceSuccess = result =>
  getBindingDeviceOutcome(result) === BINDING_OUTCOME.SUCCESS

const clearBindOrderCache = () => {
  try {
    localStorage.removeItem('ontBindOrder')
  } catch {
    // ignore
  }
}

/**
 * 已绑定：清缓存并跳转对应 Dashboard。
 * @param {{ platformType?: string, router?: { push?: Function } }} [opts]
 */
export const redirectAfterAlreadyBound = ({ platformType, router } = {}) => {
  clearBindOrderCache()
  refreshSidebarDevices()

  const target = getDashboardPathByPlatform(platformType)

  if (typeof router?.push === 'function') {
    router.push(target)
  } else if (typeof window !== 'undefined') {
    Router.push(target)
  }
}

/**
 * 统一处理绑定接口结果：toast + already_bound 跳转。
 * @returns {{ outcome: string, ok: boolean, shouldContinue: boolean }}
 */
export const resolveBindingDeviceResponse = (
  result,
  { platformType, router, onMessage, t } = {}
) => {
  const outcome = getBindingDeviceOutcome(result)
  const translate = typeof t === 'function' ? t : key => key
  const notify = typeof onMessage === 'function' ? onMessage : () => {}

  if (outcome === BINDING_OUTCOME.ALREADY_BOUND) {
    notify({
      content: result?.msg || translate('Device already bound'),
      type: 'info'
    })
    redirectAfterAlreadyBound({ platformType, router })

    return { outcome, ok: true, shouldContinue: false }
  }

  if (outcome === BINDING_OUTCOME.SUCCESS) {
    refreshSidebarDevices()

    return { outcome, ok: true, shouldContinue: true }
  }

  if (outcome === BINDING_OUTCOME.EXPIRED) {
    notify({
      content: translate('device expired') || result?.msg || 'Expired',
      type: 'error'
    })

    return { outcome, ok: false, shouldContinue: false }
  }

  if (result?.msg) {
    notify({ content: result.msg, type: 'error' })
  }

  return { outcome, ok: false, shouldContinue: false }
}
